<div class="quicklink">
  <div class="imageCont">
    @if (quicklink.iconDataUrl) {
      <img [src]="sanitizer.bypassSecurityTrustResourceUrl(quicklink.iconDataUrl)" />
    }

    @if (!quicklink.iconDataUrl) {
      <span class="{{ fallbackIcon }} placeholder"></span>
    }
  </div>

  <div class="content">
    <div class="nameCont">
      <div class="name">
        {{ quicklink.name }}
      </div>
    </div>

    <a [href]="generateQuicklinkURL(quicklink.iconUrl, quicklink.linkUrl)" target="_blank">Open</a>
  </div>
</div>
